var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"faq-item",class:{ open: _vm.item.isOpen }},[_c('button',{staticClass:"faq-item__head",on:{"click":function($event){return _vm.setItemOpen(_vm.item.id)}}},[_vm._v(" "+_vm._s(_vm.item.question)+" ")]),_c('div',{staticClass:"faq-item__body"},[_vm._v(_vm._s(_vm.item.answer))])])
}
var staticRenderFns = []

export { render, staticRenderFns }